/*
 * @Author: Charles Zhang
 * @Date: 2021-03-13 14:03:37
 * @Last Modified by: Charles Zhang
 * @Last Modified time: 2021-03-13 19:37:29
 */

import React, { Component } from "react";
import PubSub from "pubsub-js";

import { Card, Button, Table, Loading } from "element-react";

export default class BatchResultCluster extends Component {
  state = {
    columns: [
      {
        label: "名称",
        prop: "cluster",
        width: 100,
      },
      {
        label: "文档",
        prop: "documents",
        render: (data) => {
          return (
            <div className="my-3">
              {data.documents.map((docObj) => {
                let buttonType = "primary";

                const id = docObj.doc_id;
                const title = docObj.title;

                const { switchSummaryToDetail } = this.props;


                return (
                  <Button
                    key={id}
                    size="mini"
                    className="ml-0 mr-1 my-2"
                    type={buttonType}
                    onClick={() => {
                      PubSub.publish("fetchBatchDocument", { id });
                      switchSummaryToDetail(id, title);
                    }}
                  >
                    {`${title}`}
                  </Button>
                );
              })}
            </div>
          );
        },
      },
    ],
  };

  render() {
    const { columns } = this.state;

    const { clusterList, isClusterResultLoading } = this.props;

    return (
      <>
        <Card
          className="box-card"
          bodyStyle={{
            padding: 0,
            height: window.innerHeight - 330,
            overflow: "auto",
          }}
          header={
            <div className="clearfix">
              <span style={{ lineHeight: "36px" }} className="h6 text-muted">
                本批次内容
              </span>
              <span style={{ float: "right" }}>
                {/*<Button type="primary">重新加载</Button>*/}
              </span>
            </div>
          }
        >
          <Loading text="正在下载本批次内容" loading={isClusterResultLoading}>
            <Table
              style={{ width: "100%", overflowX: "hidden" }}
              columns={columns}
              data={clusterList}
              showHeader={false}
              stripe={true}
              border={true}
            />
          </Loading>
        </Card>
      </>
    );
  }
}
